'use strict';

var Sugar = require('sugar-core');

require('./build/buildMathAliasesCall');

module.exports = Sugar.Number.acos;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/acos.js
// module id = 649
// module chunks = 0